import React, {Component} from 'react';
import HeaderSectionComponent from '../HeaderSectionComponent/HeaderSectionComponent';
import TandCComponent from '../TandCComponent/TandCComponent';
import CalloutCardComponent from '../CalloutCardComponent/CalloutCardComponent';
import PasswordResetRequestComponent from '../PasswordResetRequestComponent/PasswordResetRequestComponent';

class PasswordResetRequestPageComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
            errorTitle: ''
        };
    }

    clearAlert = () => {
        this.setState({error: '', errorTitle: ''});
    }

    handleError = (error, errorTitle) => {
        this.setState({error, errorTitle});
    }

    render() {
        const {lingua, multiUserEnabled} = this.props;
        const {error, errorTitle} = this.state;
        let title = this.props.isLegacy === true ? lingua.read('lex.header.legacy') : lingua.read('lex.header.password');
        let subtitle = this.props.isLegacy === true ? lingua.read('lex.legacy.subheader') : null;
        let cardContent = (
            <PasswordResetRequestComponent
                handleError={this.handleError}
                {...this.props}
            />
        );
        return (
            <div className="ResetRequestPageComponent border-border-color">
                <HeaderSectionComponent title={title} subtitle={subtitle}/>
                <CalloutCardComponent content={cardContent} error={error} errorTitle={errorTitle} clearAlert={this.clearAlert}/>
                <TandCComponent lingua={lingua} multiUserEnabled={multiUserEnabled}/>
            </div>
        );
    }
}

export default PasswordResetRequestPageComponent;
